import { PureComponent, Children, cloneElement } from 'react'
import styled from 'styled-components'

const Container = styled.div`
    display: flex;
`
class ButtonGroup extends PureComponent {
    state = { selectedIndex: -1 }
    render() {
        const { children, className } = this.props
        const { selectedIndex } = this.state
        return (
            <Container className={className}>
                {Children.toArray(children).map((child, index) =>
                    cloneElement(child, {
                        onClick: () =>
                            this.setState({
                                selectedIndex: index,
                            }),
                        selected: index === selectedIndex,
                        index,
                    }),
                )}
            </Container>
        )
    }
}

export default ButtonGroup
